export const PLATFORM_KEYS = [
    { key: "P009", label: "NJS", url: "https://gameflex-p000.iforium.com" },
    { key: "L020", label: "NJP", url: "https://gameflex-l020.game-flex.us" },
    { key: "L022", label: "PAP", url: "https://gameflex-l022.game-flex.us" },
    { key: "L023", label: "MIP", url: "https://gameflex-l023.game-flex.us" },
    { key: "L024", label: "ONP", url: "https://gameflex-l024.game-flex.us" },
    { key: "L025", label: "CTP", url: "https://gameflex-l025.game-flex.us" },
];

export const MARKET_TYPES = {
    STAGING: 'S',
    PRODUCTION: 'P',
    MARKET_IDS: {
        STAGING: '67',
        PRODUCTION: '71'
    }
};